export const AGGR_TYPE = [ "sum", "average", "min", "max", "variance", "standardDeviation", "median" ];

export const REGRESS_TYPE = [ "regression" ];
//# sourceMappingURL=marker.js.map